module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-relative p-3"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-card', {
    staticClass: "mb-4 border-0 position-relative overflow-hidden glass-card",
    attrs: {
      "shadow-sm": ""
    }
  }, [(_vm.volumeLoading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'loading-blur': _vm.volumeLoading
    }
  }, [_c('h6', {
    staticClass: "font-weight-bold mb-3"
  }, [_c('md-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("trending_up")]), _vm._v(" Trip Volume Trends")], 1), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": "area",
      "height": "280",
      "options": _vm.tripVolumeOptions,
      "series": _vm.tripVolumeSeries
    }
  })], 1)])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-card', {
    staticClass: "mb-4 border-0 position-relative overflow-hidden glass-card",
    attrs: {
      "shadow-sm": ""
    }
  }, [(_vm.availabilityLoading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'loading-blur': _vm.availabilityLoading
    }
  }, [_c('h6', {
    staticClass: "font-weight-bold mb-3"
  }, [_c('md-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("donut_large")]), _vm._v(" Fleet Availability Ratio")], 1), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": "radialBar",
      "height": "280",
      "options": _vm.availabilityOptions,
      "series": _vm.availabilitySeries
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-card', {
    staticClass: "mb-4 border-0 position-relative overflow-hidden glass-card",
    attrs: {
      "shadow-sm": ""
    }
  }, [(_vm.activityLoading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'loading-blur': _vm.activityLoading
    }
  }, [_c('h6', {
    staticClass: "font-weight-bold mb-3"
  }, [_c('md-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("insert_chart")]), _vm._v(" Vehicle-wise Trip Activity (Top 10)")], 1), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "280",
      "options": _vm.vehicleTripsOptions,
      "series": _vm.vehicleTripsSeries
    }
  })], 1)])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-card', {
    staticClass: "mb-4 border-0 position-relative overflow-hidden glass-card",
    attrs: {
      "shadow-sm": "",
      "bg-variant": "light"
    }
  }, [(_vm.auditLoading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'loading-blur': _vm.auditLoading
    }
  }, [_c('h6', {
    staticClass: "text-primary font-weight-bold mb-3"
  }, [_c('md-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("account_balance")]), _vm._v(" Transport Accounting Audit")], 1), _vm._v(" "), _c('div', {
    staticClass: "audit-stats-container p-3 rounded bg-white shadow-sm mb-3"
  }, [_c('div', {
    staticClass: "row text-center my-3"
  }, [_c('div', {
    staticClass: "col-4 border-right"
  }, [_c('div', {
    staticClass: "text-muted xs-font mb-1"
  }, [_vm._v("TOTAL TRIPS")]), _vm._v(" "), _c('div', {
    staticClass: "h5 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.auditStats.totalTrips))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 border-right"
  }, [_c('div', {
    staticClass: "text-muted xs-font mb-1 text-success"
  }, [_vm._v("BILLED")]), _vm._v(" "), _c('div', {
    staticClass: "h5 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.auditStats.billedTrips))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "text-muted xs-font mb-1 text-warning"
  }, [_vm._v("UNBILLED")]), _vm._v(" "), _c('div', {
    staticClass: "h5 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.auditStats.unbilledTrips))])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-light p-2 rounded text-center mb-3"
  }, [_c('div', {
    staticClass: "xs-font text-muted mb-1 text-uppercase letter-spacing-1"
  }, [_vm._v("Total Billed Revenue")]), _vm._v(" "), _c('div', {
    staticClass: "h3 font-weight-bold mb-0 text-primary"
  }, [_vm._v("₹" + _vm._s(Number(_vm.auditStats.billedRevenue || 0).toLocaleString('en-IN')))])]), _vm._v(" "), _c('b-progress', {
    staticClass: "mb-3",
    attrs: {
      "height": "8px",
      "show-progress": "",
      "animated": ""
    }
  }, [_c('b-progress-bar', {
    attrs: {
      "value": _vm.auditStats.billedTrips,
      "max": _vm.auditStats.totalTrips,
      "variant": "success"
    }
  }), _vm._v(" "), _c('b-progress-bar', {
    attrs: {
      "value": _vm.auditStats.unbilledTrips,
      "max": _vm.auditStats.totalTrips,
      "variant": "warning"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between xs-font text-muted"
  }, [_c('span', [_c('span', {
    staticClass: "dot healthy mr-1"
  }), _vm._v(" Completion: "), _c('strong', [_vm._v(_vm._s(_vm.auditStats.totalTrips > 0 ? Math.round((_vm.auditStats.billedTrips / _vm.auditStats.totalTrips) * 100) : 0) + "%")])]), _vm._v(" "), _c('span', [_vm._v("Target: 100%")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info border-0 py-2 px-3 small d-flex align-items-center mb-0"
  }, [_c('md-icon', {
    staticClass: "mr-2 text-info",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('span', [_vm._v("This audit monitors trips marked as completed but awaiting final billing execution in Tally records.")])], 1)])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "mb-4 border-0 position-relative overflow-hidden glass-card",
    attrs: {
      "shadow-sm": ""
    }
  }, [(_vm.fuelLoading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'loading-blur': _vm.fuelLoading
    }
  }, [_c('h6', {
    staticClass: "font-weight-bold mb-3"
  }, [_c('md-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("speed")]), _vm._v(" Fuel Efficiency Trend (Avg KM/L)")], 1), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": "line",
      "height": "280",
      "options": _vm.fuelTrendOptions,
      "series": _vm.fuelTrendSeries
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eed7b36","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/OperationsIntelligenceTab.vue
// module id = 2492
// module chunks = 0